export default {
    HOME: 'home',
    FATURAS: 'faturas',
    MEUS_CARROS: 'pedidos',
    SERVICOS: 'servicos',
    SELECAO_EMPRESA: 'selecao-empresa',
    CARRO_CONECTADO: 'carro-conectado',
    CONTATOS: 'contatos',
    LOGOUT: 'logout',

    properties: {
        'home': {
            label: 'Home',
            path: '/'
        },
        'faturas': {
            label: 'Faturas',
            path: '/faturas'
        },
        'pedidos': {
            label: 'Meus carros',
            path: '/pedidos'
        },
        'servicos': {
            label: 'Serviços',
            path: '/servicos'
        },
        'selecao-empresa': {
            label: 'Alterar empresa',
            path: '/selecao-empresa'
        },
        'carro-conectado': {
            label: 'Carro conectado',
            path: '/carro-conectado'
        },
        'contatos': {
            label: 'Fale com a gente',
            path: '/contatos'
        },
        'logout': {
            label: 'Sair',
            path: '/signout'
        }
    }
}